import React, { FC, useState } from 'react';
import definicoescliente from '../../definicoes-cliente.json';

interface ServicosModelo {
  ServicoImagem: string;
  ServicoTitulo: string;
  ServicoDescricao: string;
  ServicoNomeBotao: string;
  ServicoLinkBotao: string;
}

const dadosTexto = {
  Titulo: 'Nossos Serviços',
  Texto: 'Confiança é a base do nosso compromisso com o associado. Nosso propósito é oferecer tranquilidade para quem usa seu veículo, para lazer ou trabalho. Seja carro, moto ou caminhão, nós temos a melhor proteção para garantir sua satisfação quando precisar usar algum benefício.'
};

const servicesData: ServicosModelo[] = [
  {
    ServicoImagem: '/images/servm3-3.jpg',
    ServicoTitulo: 'Assistência 24h',
    ServicoDescricao: 'Confiança é a base do nosso compromisso com o associado.',
    ServicoNomeBotao: "String",
    ServicoLinkBotao: "String"
  },
  {
    ServicoImagem: '/images/servm3-1.jpg',
    ServicoTitulo: 'Clube de Vantagens',
    ServicoDescricao: 'Confiança é a base do nosso compromisso com o associado.',
    ServicoNomeBotao: "String",
    ServicoLinkBotao: "String"
  },
  {
    ServicoImagem: '/images/servm2-med.jpg',
    ServicoTitulo: 'Telemedicina',
    ServicoDescricao: 'Confiança é a base do nosso compromisso com o associado.',
    ServicoNomeBotao: "String",
    ServicoLinkBotao: "String"
  },
];

const Servicos: FC = () => {
  const [activeTab, setActiveTab] = useState(0);
  const servicos = definicoescliente?.Servico?.Servicos?.length ? definicoescliente.Servico.Servicos : servicesData;
  return (
    <section id="servicos" className="text-center my-10 px-6 lg:px-14 py-12">
      <h2 className="text-textotitulo font-bold mb-4">{definicoescliente?.Servico?.Titulo || dadosTexto.Titulo}</h2>
      <p className="text-theme-dark text-textopadrao mb-8 max-w-xl mx-auto">{definicoescliente?.Servico?.Descricao || dadosTexto.Texto}</p>

      {/* Tab Menu */}
      <div className="border-b mb-6 overflow-x-auto">
        <ul className="flex flex-nowrap justify-center gap-2">
        {servicos.map((service, index) => (
            <li
              key={index}
              className={`cursor-pointer py-2 px-4 whitespace-nowrap ${
                activeTab === index ? 'border-b-2 border-theme-secondary font-semibold' : ''
              }`}
              onClick={() => setActiveTab(index)}
            >
              {service.ServicoTitulo}
            </li>
          ))}
        </ul>
      </div>

      {/* Conteúdo da Aba */}
      <div className="flex flex-col md:flex-row items-center md:justify-center">
        <img
          src={servicos[activeTab].ServicoImagem}
          alt={servicos[activeTab].ServicoTitulo}
          className="rounded-lg mb-4 md:mb-0 md:mr-8 h-auto max-h-[300px] w-full max-w-xs sm:max-w-sm md:max-w-md"
        />
        <div className="text-center md:text-left md:w-1/2 flex flex-col items-center md:items-start justify-center">
          <h3 className="text-textotitulo font-semibold mb-4">{servicos[activeTab].ServicoTitulo}</h3>
          <p className="text-theme-dark text-textopadrao mb-6 max-w-2xl">{servicos[activeTab].ServicoDescricao}</p>
          <a
            href={servicos[activeTab].ServicoLinkBotao}
            className="uppercase text-textopadrao bg-theme-secondary px-6 py-2 text-theme-light-secondary rounded shadow-md hover:bg-white border-2 border-transparent hover:border-theme-secondary hover:text-theme-secondary cursor-pointer transition duration-200"
          >
            {servicos[activeTab].ServicoNomeBotao}
          </a>
        </div>
      </div>
    </section>
  );
};

export default Servicos;
